import { Theme } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { IDashboardSettingsItem } from 'components/domain/dashboard/DashboardSettingsItem/DashboardSettingsItem';
import { TimeEntryActionBarContextProvider } from 'components/domain/time-entry/TimeEntryActionBar/TimeEntryActionBarContext';
import { ActivityReportType } from 'containers/activity-reports/ActivityReportFilter/ActivityReportFilter';
import ActivityDetailsDialog from 'containers/activity-reports/activity-report-details/ActivityDetailsDialog/ActivityDetailsDialog';
import ChannelContextProvider from 'contexts/ChannelContext/ChannelContext';
import { useOpenable } from 'hooks';
import { isNull } from 'lodash';
import { ClassName } from 'types/ClassName';
import useActiveCardReportNavigation from '../../hooks/useActiveCardReportNavigation';
import useActivityReportDetailNavigation from '../../hooks/useActivityReportDetailNavigation';
import ActiveProjectsDashboardCardContent from '../ActiveProjectsDashboardCardContent/ActiveProjectsDashboardCardContent';
import { defaultActiveProjectDashboardCardTimeFrame } from '../constants/constants';
import useActiveProjectDashboard from './hooks/useActiveProjectsDashboard';

export interface IActiveProjectsDashboardCardProps {
  theme: Theme.DARK | Theme.LIGHT;
  setting: IDashboardSettingsItem;
  onHide: () => void;
  className?: ClassName;
  memberId?: string | null;
  costCodeId?: string | null;
  equipmentId?: string | null;
  includeAddOns?: boolean;
}

const ActiveProjectsDashboardCard = ({
  setting,
  theme,
  onHide,
  className,
  memberId,
  costCodeId,
  equipmentId,
  includeAddOns,
}: IActiveProjectsDashboardCardProps) => {
  const activityReportNavigation = useActiveCardReportNavigation(setting.options?.time, 'by-project');
  const { timeRangeType, navRange, getActivityReportFilter, getActivityReportFilterType } =
    useActivityReportDetailNavigation(setting.options?.time, memberId, costCodeId, equipmentId);
  const activityReportDetailsDialog = useOpenable();
  const timeFrmae = setting.options?.time ?? defaultActiveProjectDashboardCardTimeFrame;

  const { data, loading, error, execute } = useActiveProjectDashboard(
    timeFrmae,
    memberId,
    costCodeId,
    equipmentId,
    includeAddOns
  );
  function handleRightClick() {
    if (isNull(getActivityReportFilter())) {
      activityReportNavigation();
    } else {
      activityReportDetailsDialog.open();
    }
  }

  const classes = classNames('active-project-dashboard-card', className);

  return (
    <>
      <ActiveProjectsDashboardCardContent
        className={classes}
        data={data}
        loading={loading}
        error={error}
        onReload={execute}
        onDetailClick={handleRightClick}
        theme={theme}
        onHide={onHide}
        setting={setting}
      />
      {!isNull(timeRangeType) && !isNull(navRange) && (
        <TimeEntryActionBarContextProvider>
          <ChannelContextProvider>
            <ActivityDetailsDialog
              isOpen={activityReportDetailsDialog.isOpen}
              onClose={activityReportDetailsDialog.close}
              timeRange={navRange}
              timeRangeType={timeRangeType}
              filterType={getActivityReportFilterType()}
              filterId={getActivityReportFilter()}
              initialReportType={ActivityReportType.BY_PROJECT}
            />
          </ChannelContextProvider>
        </TimeEntryActionBarContextProvider>
      )}
    </>
  );
};

export default ActiveProjectsDashboardCard;
